import React from 'react';

const ManagementTaskPage: React.FC = () => {
    return (
        <div>
            ManagementTaskPage
        </div>
    );
};

export { ManagementTaskPage }
